import { type IntegrationServices, services as moduleServices } from './services';
import type { PossiblyAsyncIntegration } from './types/asyncIntegration';
import type { IntegrationsStore } from './types/integrationsStore';

export type { AsyncIntegration, PossiblyAsyncIntegration } from './types/asyncIntegration';
export type {
  Integration,
  IntegrationConfig,
  IntegrationMetadata,
  ResolvedIntegration,
} from './types/integration';
export type { IntegrationInstallation } from './types/integrationInstallation';
export type { IntegrationsStore } from './types/integrationsStore';
export type { InstallOptions } from './utils/install';
export type { UninstallOptions } from './utils/uninstall';

export { defineAsyncIntegration } from './defineAsyncIntegration';
export { defineIntegration } from './defineIntegration';
export { useInstallation } from './useInstallation';
export { useInstallations } from './useInstallations';
export { useIntegration } from './useIntegration';
export { useIntegrations } from './useIntegrations';

export const setupIntegrations = async <
  Store extends IntegrationsStore<Record<string, PossiblyAsyncIntegration>>,
>(
  services: IntegrationServices<Store>,
) => {
  Object.assign(moduleServices, services);
};

export default {
  install: async () => {},
};
